import Footer from './layout/footer';
import Header from './layout/header';
import Home from './home/home';
import Product from './product/product';
import Slideshow from './slideshow/slideshow';
import Blog from './blog/blog';
import Article from './blog/article';
import * as $ from 'jquery';

export default class App {

    private body:any;
    private footer: Footer;
    private header: Header;
    private module: any;
    private mobileMaxWidth: number;

    constructor() {
        this.mobileMaxWidth = 768;
        this.body = $('body');

        $(document).ready(() => {
            this.initCommons();
            this.initModules();
        });
    }

    initModules() {
        this.body = $('body');

        // Home page
        if (this.body.hasClass('tshhome-index-index')) {
            this.module = new Home();
        }

        // Blog
        if (this.body.hasClass('tshblog-index-index') ) {
            this.module = new Blog();
        }

        //article
        if(this.body.hasClass('tshblog-index-article')) {
            this.module = new Article();
        }

        // Product
        if (this.body.hasClass('catalog-product-view')) {
            if ($('.product-view-container').length) {
                this.module = new Product();
            } else {
                this.initObserver();
            }

        }

        // 404
        if (this.body.hasClass('tsh404-index-index')) {
            this.module = new Product();
        }

        //empty cart
        if (this.body.hasClass('checkout-cart-index') && document.getElementById('cart-empty')) {
            this.module = new Product();
        }

        //Landing page Formawell
        if (this.body.hasClass('catalog-formawell-index')) {
            this.module = new Product();
        }
    }

    initObserver() {
        const config = { attributes: true, childList: true, characterData: true };
        const target = document.querySelector('.col-main');

        let observer = new MutationObserver(function(mutations, observer) {
            for (let i = 0; i < mutations.length; i++) {
                if (mutations[i].type === 'childList') {
                    observer.disconnect();
                    this.module = new Product();
                    break;
                }
            }
        });

        observer.observe(target, config);
    }

    initCommons() {
        this.header = new Header();
        this.footer = new Footer();
    }

    isMobile() {
        return $(window).width() < this.mobileMaxWidth;
    }

    public getFooter() {
        return this.footer;
    }

    public getHeader() {
        return this.header;
    }

}